import {Component, inject, OnInit, ViewChild} from '@angular/core';
import {BaseComponent} from "../BaseComponent";
import {ActivatedRoute, Router} from "@angular/router";
import jwtDecode, {JwtPayload} from "jwt-decode";
import {ResetPasswordRequest} from "../../models/auth/ResetPasswordRequest";
import {Paths} from "../../utils/Paths";
import {SaveNewPasswordCB} from "../../ope/auth/SaveNewPasswordCB";
import {AuthOpeService} from "../../services/ope/authOpe.service";
import {DxFormComponent} from "devextreme-angular";
import validationEngine from "devextreme/ui/validation_engine";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent extends BaseComponent implements OnInit {

  receivedToken!: string;
  checkTokenValidity = false;
  resetPasswordReq!: ResetPasswordRequest;
  readonly TOKEN_PARAMETER = 'token';
  readonly formValidationGroup = 'resetPassword';
  @ViewChild(DxFormComponent, {static: false}) form!: DxFormComponent;
  private theRoute = inject(ActivatedRoute);
  private route = inject(Router);
  private authOpeService = inject(AuthOpeService);

  ngOnInit(): void {
    super.ngOnInit();

    if (this.theRoute.snapshot.queryParamMap.has(this.TOKEN_PARAMETER)) {
      const theReceivedToken = this.theRoute.snapshot.queryParamMap.get(this.TOKEN_PARAMETER);

      if (theReceivedToken !== null && this.checkIfTokenIsValid(theReceivedToken)) {
        // manage token

        this.receivedToken = theReceivedToken;

        this.checkTokenValidity = true;

        this.resetPasswordReq = new ResetPasswordRequest();
        this.resetPasswordReq.username = jwtDecode<JwtPayload>(theReceivedToken).sub ?? '';

      } else {
        this.logger.error("Received token null or expired.");
        this.toastService.openTranslatedErrorToastMessage('ERROR.PASSWORD_RESET_LINK_ERROR');
        this.route.navigate([Paths.LOGIN], {});
      }

    } else {
      this.logger.error("token parameter not found.");
      this.toastService.openTranslatedErrorToastMessage('ERROR.PASSWORD_RESET_LINK_ERROR');
      this.route.navigate([Paths.LOGIN], {});
    }

    // // SET LANGUAGE
    // this.be.setLanguage('en');
    //
    // // fetch token
    // this.activatedRoute.params.subscribe(urlParams => {
    //   this.receivedToken = urlParams.token;
    // });

  }

  changePasswordMode = (name: string) => {
    let editor = this.form.instance.getEditor(name);
    if (!!editor) {
      editor.option(
        'mode',
        editor.option('mode') === 'text' ? 'password' : 'text',
      );
    }
  };

  usernameEditorOptions = {
    disabled: true
  };

  newPasswordEditorOptions = {
    mode: 'password',
    valueChangeEvent: 'keyup',
    buttons: [
      {
        name: 'newPassword',
        location: 'after',
        options: {
          icon: 'eyeopen',
          stylingMode: 'text',
          onClick: () => this.changePasswordMode('newPassword'),
        },
      }
    ],
  };
  confirmPasswordEditorOptions = {
    mode: 'password',
    valueChangeEvent: 'keyup',
    buttons: [
      {
        name: 'confirmPassword',
        location: 'after',
        options: {
          icon: 'eyeopen',
          stylingMode: 'text',
          onClick: () => this.changePasswordMode('confirmPassword'),
        },
      }
    ],
  };

  checkFormValidity() {
    if (!!validationEngine.getGroupConfig(this.formValidationGroup)) {
      if (validationEngine.validateGroup(this.formValidationGroup).isValid) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  changePassword() {

    if (this.checkFormValidity()) {
      const cb = new SaveNewPasswordCB();

      cb.i.username = this.resetPasswordReq.username;
      cb.i.newHashedPassword = this.authOpeService.hashPassword(this.resetPasswordReq.newPassword);

      this.authOpeService.saveNewPassword(cb, this.receivedToken).then(_ => {
        this.toastService.openTranslatedSuccessToastMessage('RESET_PASSWORD.SUCCESS');
        this.route.navigateByUrl(Paths.LOGIN, {});
      });
    } else if (!!this.resetPasswordReq.newPassword && this.resetPasswordReq.newPassword !== this.resetPasswordReq.confirmPassword) {
      this.toastService.openTranslatedErrorToastMessage('ERROR.PASSWORDS_MISMATCH');
    } else {
      this.toastService.openTranslatedErrorToastMessage('ERROR.MISSING_INFORMATION');
    }

  }

  newPasswordValue = () => {
    return this.resetPasswordReq.newPassword;
  }

  private checkIfTokenIsValid(token: string) {

    try {
      const tokenPayload = jwtDecode<JwtPayload>(token);

      return !!tokenPayload.exp && tokenPayload.exp > Math.floor(Date.now() / 1000);
    } catch (e) {
      this.logger.error(e);
      return false;
    }

  }
}
